import PersonCard from "../../../_components/PersonCard";
import ExamDetailsCard from "./ExamDetailsCard";
import { EventState } from "../index";
import SectionHeading from "@/components/SectionHeading";

interface EventInformationSectionProps {
  eventState: EventState;
  onStateUpdate: (update: Partial<EventState>) => void;
  userCanEdit: boolean;
}

export const EventInformationSection = ({ eventState, onStateUpdate, userCanEdit }: EventInformationSectionProps) => {
  const handleExamDetailsUpdate = async (details: { conditions: string; problems: string }) => {
    onStateUpdate({
      patEventAttributes: {
        ...eventState.patEventAttributes,
        courseConditions: details.conditions,
        problemsIssues: details.problems
      }
    });
  };

  return (
    <>
      <SectionHeading heading="Event Information" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-stretch">
        <PersonCard
          title="Event Host"
          pgaId={eventState.patEventAttributes.hostProfessional.pgaId}
          name={eventState.patEventAttributes.hostProfessional.displayName}
          onSave={(newHost) => {
            onStateUpdate({
              patEventAttributes: {
                ...eventState.patEventAttributes,
                hostProfessional: {
                  id: newHost.id,
                  pgaId: newHost.pgaId,
                  displayName: newHost.displayName
                }
              }
            });
          }}
          userCanEdit={userCanEdit}
        />
        <PersonCard
          title="PAT Examiner"
          pgaId={eventState.patEventAttributes.examiner.pgaId}
          name={eventState.patEventAttributes.examiner.displayName}
          onSave={(newExaminer) => {
            onStateUpdate({
              patEventAttributes: {
                ...eventState.patEventAttributes,
                examiner: { id: newExaminer.id, pgaId: newExaminer.pgaId, displayName: newExaminer.displayName }
              }
            });
          }}
          userCanEdit={userCanEdit}
        />
        <ExamDetailsCard
          conditions={eventState.patEventAttributes.courseConditions}
          problems={eventState.patEventAttributes.problemsIssues}
          onSave={handleExamDetailsUpdate}
          userCanEdit={userCanEdit}
        />
      </div>
    </>
  );
};
